<link rel="stylesheet" href="/aragon.css" />

<div class="main-content h-100vh" style="background-color: antiquewhite">
    <div class="header py-7 py-lg-8 pt-lg-9" style="background-color: #eb690d">
        <div class="separator separator-bottom separator-skew zindex-100">
            <svg
                x="0"
                y="0"
                viewBox="0 0 2560 100"
                preserveAspectRatio="none"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 223px"
            >
                <polygon style="fill: antiquewhite" points="2560 0 2560 100 0 100"></polygon>
            </svg>
        </div>
    </div>

    <div class="container pb-5">
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7" style="margin-top: -116px">
                <div class="card border-0 mb-0">
                    <div class="text-center">
                        <img src="/assets/images/bg1.jpeg" class="img-fluid" style="width: 320px" />
                    </div>

                    <div class="card-body px-lg-5">
                        <div class="text-center mb-4">
                            <h4 style="color: #f67b13">Sign in</h4>
                        </div>

                        <form role="form">
                            <div class="form-group mb-3">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" style="background-color: white"
                                        ><i class="fa-sharp fa-solid fa-envelope" style="color: darkgray"></i
                                    ></span>

                                    <input class="form-control" placeholder="Email" type="email" name="userName" [(ngModel)]="userName" />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" style="background-color: white"
                                        ><i class="fa-sharp fa-solid fa-unlock" style="color: darkgray"></i
                                    ></span>
                                    <input
                                        class="form-control"
                                        placeholder="Password"
                                        name="password"
                                        type="password"
                                        [(ngModel)]="password"
                                    />
                                </div>
                            </div>
                            <div class="custom-control custom-control-alternative custom-checkbox">
                                <input class="custom-control-input" id=" customCheckLogin" type="checkbox" />
                                <label class="custom-control-label" for=" customCheckLogin">
                                    <span class="px-1" style="color: dimgrey">Remember me</span>
                                </label>
                            </div>
                            <div class="text-center py-2">
                                <button
                                    type="button"
                                    class="btn btn-primary my-4 px-3"
                                    (click)="onSignin()"
                                    style="background-color: #e86f09; border: none"
                                >
                                    Sign in
                                </button>
                            </div>
                        </form>

                        <div class="row mt-3 text-center">
                            <div>
                                <a href="javascript:void(0)" class="text-decoration-none text-black">
                                    <small> Forgot password? </small>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="color: orangered" class="position-absolute bottom-0 text-center">
                <p>&copy; 2023 Tedlance IT Solutions</p>
            </div>
        </div>
    </div>
</div>
